define('shoptheme/components/product/type/configurable',[
	"jquery",
	"lodash",
	"cartware/components/Registry",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"bootstrap-popover",
	"bootstrap-button"
], function(
	$,
	_,
	Registry,
	Component,
	BEM
) {

	var $document = $(document);

	function triggerEvent(element, eventName) {
		if ("dispatchEvent" in element) {
			var evt = document.createEvent("HTMLEvents");
			evt.initEvent(eventName, false, true);
			element.dispatchEvent(evt);
		} else if ("fireEvent" in element) {
			element.fireEvent("on" + eventName);
		}
	}

	return Component.create({
		simpleItems:		null,
		stockBlock:			null,
		priceBlock:			null,

		$init: function() {
			var $document = $(document);

			$document.trigger('product/configurable/uninstall');

			$document.on('product/changeGallerySimple', function() {

			});

			this.simpleItems = $(".options-simples li");

			//this.installButtonPopover();

			this.stockBlock = BEM.block("product-detail-stock-status");
			this.priceBlock = BEM.block("product-detail-price");

			this.initializeEvents();
			this.initializeStock();
			this.initializePrice();

			/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
				Catalog :: Product :: Configurable :: Attribute options
			 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
			$('.input-box').on('click', '.attribute-option', function(e) {
				var item = $(this)
					, attributeId = item.data('attribute-id')
					, attributeValue = item.data('attribute-value')
					, select = $('#attribute' + attributeId);

				select.val(attributeValue);
				triggerEvent(select.get(0), 'change');
			});

			/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
				Catalog :: Product :: Configurable :: Multiple images
			 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
			;(function() {
				var template = $('#media-additional-template').html()
					, targetNode = $('#product-thumbnails');

				;(function() {
					function _onChangeGallerySimple(e, simple) {
						var images = [];

						for (var i = 0, j = simple.mediaImages.length; i < j; i++) {
							images.push(simple.mediaImages[i]);
						}

						images.reverse();

						var renderedTemplate = _.template(template, { images : images, simple : simple });
						targetNode.html(renderedTemplate);
					}

					$document.on('product/changeGallerySimple', _onChangeGallerySimple);
					$document.one('product/configurable/uninstall', function() {
						$document.off('product/changeGallerySimple', _onChangeGallerySimple);
					});
				})();
			})();

			/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
			 	Catalog :: Product :: Configurable :: Delivery times
			 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
			;(function() {
				var deliveryTimeWrap = $('.delivery-time-wrap')
					, defaultDeliveryTime = deliveryTimeWrap.find('.delivery-time');

				function _onSimpleChange(e, simple) {
					if (simple) {
						defaultDeliveryTime.detach();
						deliveryTimeWrap.html(simple.deliveryTime || '');
					} else {
						deliveryTimeWrap.empty();
						defaultDeliveryTime.appendTo(deliveryTimeWrap);
					}
				}

				$document.on('product/changeSimple', _onSimpleChange);
				$document.one('product/configurable/uninstall', function() {
					$document.off('product/changeSimple', _onSimpleChange);
				});
			})();

			/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
			 	Catalog :: Product :: Configurable :: Global exposure
			 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
			if ("spConfigData" in window) {
				window.spConfig = new Product.Config(spConfigData);
				Registry().register("product.view.configurable.spConfig", spConfig);
			}

			/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
			 	Catalog :: Product :: Configurable :: Options
			 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
			$('.super-attribute-select').each(function() {
				var select = $(this)
					, attributeId = select.prop('id').replace(/[a-z]*/, '')
					, templateNode = $('#attribute-template-' + attributeId)
					, template = templateNode.html()
					, displayNode = select.parent().find('.display');

				if (!template) return;

				select.on('attribute/reset', function(e) {
					displayNode.addClass('disabled');
					$document.trigger('attribute/reset', [this, displayNode]);
				});

				select.on('attribute/fillSelect', function(e) {
					var options = []
						, state = spConfig.state || {};

					select.find('option').each(function() {
						var node = $(this)
							, option = {
								value: node.prop('value'),
								label: node.html(),
								qty: null
							};

						var configOptions = spConfig.config.attributes[attributeId].options;

						for (var i = 0, j = configOptions.length; i < j; i++) {
							if (configOptions[i].id == option.value) {
								if (configOptions[i].allowedProducts.length == 1) {
									for (var k in spConfig._configurable.simples) {
										if (k == configOptions[i].allowedProducts[0]) {
											option.qty = spConfig._configurable.simples[k].qty;
											break;
										}
									}
								}
								break;
							}
						}

						_.forEach(spConfig.dataProviders, function(provider) {
							if ("function" == typeof provider.provideSelectOption) {
								provider.provideSelectOption(option, select, attributeId);
							}
						});

						options.push(option);
					});

					function done() {
						var renderedTemplate = _.template(template, { options: options, attributeId: attributeId, state: state });
						displayNode.html(renderedTemplate);
						displayNode.removeClass('disabled');
						$document.trigger('attribute/fillSelectAfter', [this, displayNode]);
					}

					if (spConfig.dataProviders.length) {
						+function() {
							var i = 0, j = spConfig.dataProviders.length;

							function next(result) {
								var provider;

								options = result;

								if (i >= j) {
									done();
									return;
								}

								provider = spConfig.dataProviders[i];
								i++;

								if ("function" == typeof provider.sortSelectOptions) {
									options = provider.sortSelectOptions(options, attributeId);

									if ("object" === typeof options && "then" in options) { // promise
										options.then(next);
									} else {
										next(options);
									}

									return;
								}

								next(options);
							}

							next(options);
						}();
					} else {
						done();
					}
				});

				select.trigger('attribute/fillSelect');
			});
		},

		initializeStock: function() {
			var defaultElement = this.stockBlock.getElements("default"),
				tmpl = _.template(this.stockBlock.find("[data-template]").html()),
				blockCache = {},
				self = this;

			function _onSimpleChange(e, simple) {
				var status,
					block;

				if (simple) {
					status = simple.stock_status;
					block = blockCache[status] || null;

					if (!block) {
						block = $(tmpl({
							stockStatus: status
						})).bemAddModifier(status);

						blockCache[status] = block;
					}

					self.stockBlock.empty();
					self.stockBlock.append(block);
				} else {
					self.stockBlock.empty();
					self.stockBlock.append(defaultElement);
				}
			}

			$document.on('product/changeSimple', _onSimpleChange);
			$document.one('product/configurable/uninstall', function() {
				$document.off('product/changeSimple', _onSimpleChange);
			});
		},

		initializePrice: function() {
			var fromLabel = this.priceBlock.findBlock("price").getElements("label-from");

			function _onSimpleChange(e, simple) {
				var status,
					block;

				if (simple) {
					fromLabel.hide();
				} else {
					fromLabel.show();
				}
			}

			$document.on('product/changeSimple', _onSimpleChange);
			$document.one('product/configurable/uninstall', function() {
				$document.off('product/changeSimple', _onSimpleChange);
			});
		},

		//installButtonPopover: function() {
		//	var self = this;
		//
		//	if (!this.addToCartButton.length) return;
		//
		//	var template = $('#add-to-cart-popover-template').html();
		//
		//	this.addToCartButton.get(0)['hide'] = $.noop;
		//	this.addToCartButton.get(0)['show'] = $.noop;
		//
		//	this.addToCartButton.on('mouseenter', function() {
		//		if (self.addToCartButton.hasClass('disabled')) {
		//			self.addToCartButton.popover('show');
		//		}
		//	});
		//
		//	this.addToCartButton.on('mouseleave', function() {
		//		self.addToCartButton.popover('hide');
		//	});
		//
		//	this.addToCartButton.popover({
		//		title: '',
		//		content: function() {
		//			var settings = spConfig.settings;
		//
		//			if (!settings.length) return '';
		//
		//			var emptySetting = null;
		//
		//			$.each(settings, function() {
		//				if (this.disabled || this.value === '') {
		//					emptySetting = this;
		//					return false;
		//				}
		//			});
		//
		//			if (!emptySetting) return '';
		//
		//
		//			var renderedTemplate = _.template(template, { conf : $(emptySetting).data('label') });
		//			return renderedTemplate;
		//		},
		//		trigger: 'manual',
		//		placement: function() {
		//			if ($(window).width() < 768) {
		//				return "left";
		//			}
		//
		//			return "bottom";
		//		}
		//	});
		//},

		initializeEvents: function() {
			this.simpleItems.on('click', function(e) {
				var listItem = $(this)
					, value = listItem.data('attribute-value')
					, attributeId = listItem.data('attribute-id')
					, select = $('#attribute' + attributeId);

				if (select.length === 0) return;

				select.val(value);
				triggerEvent(select.get(0), 'change');
			});
		},

		destructor: function() {
			$(document).trigger('product/configurable/uninstall');
			Registry().unregister("product.view.configurable.spConfig");
			this.simpleItems = null;
			window.spConfig = null;
			delete window.spConfig;
		}
	});
});
